




































































































import Vue, { PropType } from "vue";

interface ApplicationPlansProps {
  lang: any;
  langTerm: any;
  locale: string;
  contractNumber: string;
  planCode: string;
  selectedTerm: string;
  countryChoice: any;
  currencyChoice: any;
  priceMap: any;
  nextContractRenewAtTimestamp: number;
  defaultData: any;
  action: string;
  prevUrl: string;
}

export default Vue.extend({
  name: "vc-payment-information-registration-plans",
  data() {
    return {
      currency_code: this.defaultData.currency_code,
      country_code: this.defaultData.country_code
    };
  },
  props: {
    lang: {
      type: Object as PropType<ApplicationPlansProps["lang"]>,
      default: () => {}
    },
    langTerm: {
      type: Object as PropType<ApplicationPlansProps["langTerm"]>,
      default: () => {}
    },
    locale: {
      type: String as PropType<ApplicationPlansProps["locale"]>,
      default: ""
    },
    contractNumber: {
      type: String as PropType<ApplicationPlansProps["contractNumber"]>,
      default: ""
    },
    planCode: {
      type: String as PropType<ApplicationPlansProps["planCode"]>,
      default: ""
    },
    selectedTerm: {
      type: String as PropType<ApplicationPlansProps["selectedTerm"]>,
      default: ""
    },
    countryChoice: {
      type: Array as PropType<ApplicationPlansProps["countryChoice"]>,
      default: () => []
    },
    currencyChoice: {
      type: Array as PropType<ApplicationPlansProps["currencyChoice"]>,
      default: () => []
    },
    priceMap: {
      type: Object as PropType<ApplicationPlansProps["priceMap"]>,
      default: () => {}
    },
    nextContractRenewAtTimestamp: {
      type: Number as PropType<
        ApplicationPlansProps["nextContractRenewAtTimestamp"]
      >,
      default: 0
    },
    defaultData: {
      type: Object as PropType<ApplicationPlansProps["defaultData"]>,
      default: () => {}
    },
    action: {
      type: String as PropType<ApplicationPlansProps["action"]>,
      default: ""
    },
    prevUrl: {
      type: String as PropType<ApplicationPlansProps["prevUrl"]>,
      default: ""
    }
  },
  computed: {
    firstCountryList(): Object[] {
      return this.countryChoice.filter((country: any) => {
        if (country.display_list_priority == 1) return true;
      });
    },
    secondCountryList(): Object[] {
      return this.countryChoice.filter((country: any) => {
        if (country.display_list_priority == 2) return true;
      });
    },
    price(): number {
      return this.priceMap[this.planCode][this.currency_code];
    }
  },
  methods: {
    submitPlan() {
      const formElement = this.$refs.formOffers as HTMLFormElement;

      formElement.submit();
    }
  },
  watch: {}
});
